// extracted by mini-css-extract-plugin
export var blue = "_g-f";
export var brand = "_g-b";
export var darkGrey = "_g-e";
export var disabled = "_g-4";
export var disabledSubtle = "_g-5";
export var error = "_g-6";
export var green = "_g-g";
export var grey = "_g-d";
export var icon = "_g-0";
export var inherit = "_g-a";
export var lightGrey = "_g-c";
export var orange = "_g-i";
export var pink = "_g-k";
export var primary = "_g-1";
export var purple = "_g-l";
export var red = "_g-j";
export var secondary = "_g-2";
export var success = "_g-9";
export var tertiary = "_g-3";
export var warning = "_g-7";
export var warningSecondary = "_g-8";
export var white = "_g-m";
export var yellow = "_g-h";